import './style.scss';
import {getMeetings} from "../../API/apiService";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";

function ModalMeetingEdit({handleAccept, handleCancel}) {
    const [meeting, setMeeting] = useState({});
    const [meetingsNumber, setMeetingsNumber] = useState(0);
    const [eventsNumber, setEventsNumber] = useState(0);


    function handleAcceptClick() {
        console.log('clicked')
        if(isNaN(meetingsNumber) || isNaN(eventsNumber)){
            toast('Digite un numero valido', {
                type: 'error'
            });
            return
        }
        if(meeting.meetingsNumber === meetingsNumber &&  meeting.eventsNumber === eventsNumber) {
            handleCancel()
        }else{
            meeting.meetingsNumber = Number(meetingsNumber);
            meeting.eventsNumber = Number(eventsNumber);
            handleAccept(meeting);
        }
    }

    async function getMeetingsInfo() {
        const date = new Date();
        const response = await getMeetings(date.getFullYear());
        if (response) {
            setMeeting({year: response.year, meetingsNumber: response.meetings_number, eventsNumber: response.events_number});
        } else {
            setMeeting({year: date.getFullYear(), meetingsNumber: 0, eventsNumber: 0});
        }
    }


    useEffect(() => {
        getMeetingsInfo()
    }, []);

    return (
        <section className='main-meetingModal-container'>
            <p className='title'>EDITAR ENCUENTROS</p>
            <section className='create-container'>
                <div className='currentYear-container'>
                    <p className='subYear'>Año en vigencia</p>
                    <p className='year'>{meeting?.year}</p>
                </div>
                <div className='medium-container'>
                    <p className='sub-title'>
                        Crea o edita encuentros y eventos del año en vigencia
                    </p>
                    <div className='labels-container'>
                        <label className='label' htmlFor=''>
                            <input
                                placeholder='Número de encuentros'
                                type='number'
                                name='meetingsNumber'
                                className='input-form'
                                value={meetingsNumber}
                                onChange={(e) => setMeetingsNumber(e.target.value)}
                            />
                        </label>
                        <label className='label' htmlFor=''>
                            <input
                                placeholder='Número de eventos'
                                type='number'
                                name='eventNumber'
                                className='input-form'
                                value={eventsNumber}
                                onChange={(e) => setEventsNumber(e.target.value)}
                            />
                        </label>
                    </div>
                    <p className='number-meetings'>Número de encuentros: {meeting.meetingsNumber}</p>
                    <p className='number-events'>Número de eventos: {meeting.eventsNumber}</p>
                </div>

                <div className='buttons-container'>
                    <button type={"button"} className='blue-site-button create' onClick={handleAcceptClick}>ACTUALIZAR
                    </button>
                    <button
                        onClick={handleCancel}
                        className='button-white-border-blue'>
                        CANCELAR
                    </button>
                </div>
            </section>
        </section>
    );
}

export default ModalMeetingEdit;
